export class QueryResult<T>  {

    constructor(jsonObject: any, type: new (data: any) => T) {
        if(jsonObject == null) {
            this.result = [];
            this.total = 0;            
        }
        else {
            this.result = jsonObject.result.map((r: any) => new type(r));
            this.total = jsonObject.total;
        }
    }

    public result: T[];
    public total: number;
}